module.exports = __webpack_public_path__ + "img/prize-02.3a717a83.png";